import Button from "react-bootstrap/Button";
import React, { FC } from "react";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

// controls
import { Form as FormControl } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { IObject } from "models/Common";
import {
  TabEntitySchemaType,
  Decision,
  //   TagsFormControlsValues,
} from "../contentManagementUtils/tabSchema";

type AddContentFormModalProps = {
  isOpen: boolean;
  toggle: (initialValues: null | IObject) => void;
  submitForm: (values: unknown) => void;
  headerTitle: string;
  approveBtnLabel: string;
  cancelBtnLabel: string;
  fields: TabEntitySchemaType[];
  initialValues: IObject;
  validationSchema: Yup.ObjectSchema<IObject>;
  decisions?: Decision[];
};

const AddContentForm: FC<AddContentFormModalProps> = ({
  isOpen,
  toggle,
  submitForm,
  headerTitle,
  approveBtnLabel,
  cancelBtnLabel,
  fields,
  initialValues,
  validationSchema,
  decisions,
}) => {
  const { t } = useTranslation();
  const formikProps = {
    initialValues,
    onSubmit: submitForm,
    validationSchema,
  };

  return (
    <Modal
      show={isOpen}
      onHide={() => toggle(null)}
      aria-labelledby="contained-modal-title-vcenter"
      contentClassName="form-modal"
      dialogClassName="little-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{headerTitle}</Modal.Title>
      </Modal.Header>
      <Formik {...formikProps}>
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          //   setFieldValue,
        }) => (
          <>
            <Modal.Body>
              {fields.map((fieldObj) => {
                const fieldName = Object.keys(fieldObj)[0];
                const field = fieldObj[fieldName];
                const { label, componentProps, component } = field;
                /* eslint-disable no-console */
                if (component === "select" && decisions) {
                  return (
                    <InputGroup hasValidation>
                      <FormControl.Group as={Col} md="12" className="m-3">
                        <FloatingLabel
                          controlId="floatingInput"
                          className="text-right"
                          label={label}
                        >
                          <FormControl.Select
                            size="lg"
                            name={fieldName}
                            defaultValue={values[fieldName] ?? ""}
                            onChange={handleChange}
                            className="square border border-secondary form-control select-icon-left"
                            isInvalid={
                              touched?.[fieldName] && !!errors?.[fieldName]
                            }
                            {...componentProps}
                          >
                            <option disabled value="">
                              {t("בחר החלטה...")}
                            </option>
                            {decisions.map((obj: Decision) => {
                              return (
                                <option value={obj.code}>{obj.name}</option>
                              );
                            })}
                          </FormControl.Select>
                          {errors?.[fieldName] && (
                            <FormControl.Control.Feedback type="invalid">
                              {errors?.[fieldName]}
                            </FormControl.Control.Feedback>
                          )}
                        </FloatingLabel>
                      </FormControl.Group>
                    </InputGroup>
                  );
                }
                return (
                  <Row className="mb-3" key={fieldName}>
                    <InputGroup hasValidation>
                      <FormControl.Group as={Col} md="12" className="m-3">
                        <FloatingLabel
                          controlId="floatingInput"
                          className="text-right"
                          label={label}
                        >
                          <FormControl.Control
                            size="lg"
                            name={fieldName}
                            value={values[fieldName]}
                            onChange={handleChange}
                            className="square border border-secondary form-control"
                            isInvalid={
                              touched?.[fieldName] && !!errors?.[fieldName]
                            }
                            maxLength={componentProps?.maxLength}
                            {...componentProps}
                          />
                          {errors?.[fieldName] && (
                            <FormControl.Control.Feedback type="invalid">
                              {errors?.[fieldName]}
                            </FormControl.Control.Feedback>
                          )}
                        </FloatingLabel>
                      </FormControl.Group>
                    </InputGroup>
                  </Row>
                );
              })}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => toggle(null)}>
                {cancelBtnLabel}
              </Button>
              <Button variant="primary" onClick={() => handleSubmit()}>
                {approveBtnLabel}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default AddContentForm;
